//
// object-foreach.js - iterate over an object's own properties
//

export default function object_foreach(obj, f) {
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      f(i, obj[i]);
    }
  }
}
